import React, {useState, useEffect} from 'react';
import './ProductSlider.scss';

const ProductSlider = () => {
    const [family, setFamily] = useState('1');
    const [amount, setAmount] = useState('1');
    const [total, setTotal] = useState('1');
    useEffect(() => {
        console.log("HEJ",family, amount,  '- Has changed');
        setTotal(family*amount);
    },[family,amount]);

    return (
        <>
        <p>Hur många är ni i familjen?</p>

    <div className="slideBlock">
        <div className="strack"></div>
        <div className="slideProgress" style={{"width": (family/10*100) + "%"}}></div>
    <input
    onChange={(e) => setFamily(
        e.target.value >= 1 && e.target.value <= 10 ? e.target.value : '1'
    ) }
    value={family}
    type="range"
    name="range"
    id="rangeFamily"
    min="1" max="10" />
        <div className="Family">{family}</div>
        </div>


<p>Antal nyckelbrickor per person</p>
        <div className="slideBlock">
                <div className="strack"></div>
                <div className="slideProgress" style={{"width": (amount/10*100) + "%"}}></div>
            <input
            onChange={(e) => setAmount(
                e.target.value >= 1 && e.target.value <= 10 ? e.target.value : '100'
            )}
            value={amount}
            type="range"
            name="range"
            id="range"
            min="1" max="10" />
                <div className="amount">{amount}</div>
        </div>

            Totalt {total}
    </>
);
}

export default ProductSlider;